import { render } from "./contactus-detail.vue?vue&type=template&id=dde3b0b6&scoped=true"
import script from "./contactus-detail.vue?vue&type=script&lang=js"
export * from "./contactus-detail.vue?vue&type=script&lang=js"

import "./contactus-detail.vue?vue&type=style&index=0&id=dde3b0b6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/d72e10b2-82a4-4871-b4ef-3f0bf96be7c1/workspace/site-h5_3HZM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde3b0b6"]])

export default __exports__